import { Component, OnInit,ViewChild } from '@angular/core';
import {Router} from '@angular/router';
import { UserService} from '../services/user.service';
import { DeviceService} from '../services/device.service';
import { DeviceTypeService} from '../services/device-type.service';
import { UserDeviceService } from '../services/user-device.service';
import { Message} from 'primeng/primeng';
import { ConfirmationService} from 'primeng/primeng';
import { SelectItem} from 'primeng/primeng';
import { ProfileService} from '../services/profile.service';
import { CompanyService} from '../services/company.service';
import { DatePipe } from '@angular/common';
import { Table } from 'primeng/table';

@Component({
selector: 'app-user',
templateUrl: './user.component.html',
styleUrls: ['./user.component.css'],
providers: [ConfirmationService]
})

export class UserComponent implements OnInit {

msgs: Message[] = [];
es: any;
user: any;
users : any [];
device: any;
devices : any [];
profiles:SelectItem[];
companies:SelectItem[];
typesDevice:SelectItem[];
icons:SelectItem[];
displayAdd: boolean = false;
displayEdit: boolean = false;
displayAddDevice: boolean = false;
displayEditDevice: boolean = false;
displayDevices: boolean = false;
status: SelectItem[];
blockedDocument: boolean = false;
blockSpace: RegExp = /[^\s]/;
expirationDate: Date;
displayChangePassword:boolean=false;
newPassword : String;
confirmPassword : String;
quantityUsersEnabled: number;
quantityUsersDisabled: number;
quantityUsersWithoutService: number;
statusFilter: SelectItem[];
storageTimeDisabled : boolean;
statusFilterDefault:String="H";
dayNames:String[];
@ViewChild("dt") private table: Table;

constructor(private userService : UserService,private confirmationService: ConfirmationService,
  private profileService: ProfileService,private companyService : CompanyService,
  private deviceService : DeviceService, private deviceTypeService:DeviceTypeService,
  private userDeviceService:UserDeviceService,private datePipe: DatePipe,
  private router: Router) { }

  ngOnInit() {
    this.dayNames = ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"];
    this.storageTimeDisabled = this.userService.userLoged.idProfile != 1;
    this.statusFilter = [
            {label: 'Todos', value: null },
            {label: 'Habilitado', value: 'H'},
            {label: 'Inhabilitado', value: 'I'},
            {label: 'Sin Servicio', value: 'S'}
        ];
    this.es = {
            firstDayOfWeek: 1,
            dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
            dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
            dayNamesMin: [ "D","L","M","X","J","V","S" ],
            monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
            monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
            today: 'Hoy',
            clear: 'Borrar'
        }
    this.init();
    this.status = [
      {label: 'Habilitado', value: 'H', icon: 'fa fa-check-square-o'},
      {label: 'Inhabilitado', value: 'I', icon: 'fa fa-square-o'},
      {label: 'Sin Servicio', value: 'S', icon: 'fa fa-user-times'}
    ];
    this.profiles = [];
    this.profileService.findAll().then(data => {
      let response: any = data;
      response.profiles.forEach(item => {
        if(this.userService.userLoged.idProfile == 1){
          this.profiles.push({label: item.description, value: item.idProfile});
        }else if(this.userService.userLoged.idProfile == 6){
          if(item.idProfile != 1 && item.idProfile != 6 && item.idProfile != 2 && item.idProfile != 5 && item.idProfile != 7 && item.idProfile != 8 && item.idProfile != 9){
            this.profiles.push({label: item.description, value: item.idProfile});
          }
        }else if(this.userService.userLoged.idProfile == 5){
          if(item.idProfile != 1 && item.idProfile != 6 && item.idProfile != 7 && item.idProfile != 5 && item.idProfile != 2 && item.idProfile != 3 && item.idProfile != 8 && item.idProfile != 9){
            this.profiles.push({label: item.description, value: item.idProfile});
          }
        }
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
    this.companies = [];
    this.companyService.findByUser(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.companies.forEach(item => {
        this.companies.push({label: item.businessName, value: item.idCompany});
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });

    this.typesDevice = [];
    this.deviceTypeService.findAll().then(data => {
      let response: any = data;
      response.deviceTypes.forEach(item => {
        this.typesDevice.push({label: item.name, value: item.idType});
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
    this.icons = [];
    this.icons.push({label: "car1", value: 1});
    this.icons.push({label: "car2", value: 2});
    this.icons.push({label: "car3", value: 3});
    this.icons.push({label: "car4", value: 4});
    this.icons.push({label: "car5", value: 5});
    this.icons.push({label: "car6", value: 6});
    this.icons.push({label: "car7", value: 7});
    this.icons.push({label: "car8", value: 8});
    this.icons.push({label: "car9", value: 9});
    this.icons.push({label: "car10", value: 10});
    this.icons.push({label: "car11", value: 11});
    this.icons.push({label: "car12", value: 12});
    this.icons.push({label: "car13", value: 13});
    this.icons.push({label: "car14", value: 14});
    this.icons.push({label: "car15", value: 15});
    this.icons.push({label: "car16", value: 16});
  }

  init(){
    this.users = [];
    this.quantityUsersEnabled = 0;
    this.quantityUsersDisabled = 0;
    this.quantityUsersWithoutService = 0;
    this.userService.findUsersBranch(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.users.forEach(item => {
        let dateArray = item.expirationDate.split("/");
        let expirationDate = new Date();
        expirationDate.setFullYear(dateArray[2],dateArray[1]-1,dateArray[0]);
        item.validDays = this.diferenciaEntreDiasEnDias(new Date(),expirationDate);
        this.users.push(item);
        if(item.status == 'H'){
          this.quantityUsersEnabled++;
        }else if(item.status == 'I'){
          this.quantityUsersDisabled++;
        }else if(item.status == 'S'){
          this.quantityUsersWithoutService++
        }
      });
      this.table.filter(this.statusFilterDefault, 'status', 'equals');
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
    this.user = {status:"H",idUserParent:this.userService.userLoged.idUser, limitDevices:20};
    this.displayAdd = false;
    this.displayEdit = false;
    this.device = {status:"H"};
    this.displayAddDevice = false;
    this.displayEditDevice = false;
  }

  showChangePassword(user: any){
    this.user = user;
    this.displayChangePassword = true;
  }

  showAdd(){
    this.displayAdd = true;
    this.expirationDate = new Date();
    this.expirationDate = new Date(new Date().setFullYear(this.expirationDate.getFullYear() + 1));
  }

  showEdit(user:any){
    this.user=user;
    let dateArray = this.user.expirationDate.split("/");
    this.expirationDate = new Date();
    this.expirationDate.setFullYear(dateArray[2],dateArray[1]-1,dateArray[0]);
    this.displayEdit = true;
  }

  showAddDevice(){
    this.displayAddDevice = true;
    this.device.drivingSchedules = [];
    for (let i = 1; i <= 7 ; i++) {
      let startTime= new Date();
      startTime.setHours(0,0,0);
      let endTime = new Date();
      endTime.setHours(23,59,59);
      this.device.drivingSchedules.push({
        day:i,
        dayName:this.dayNames[i-1],
        startTimeInput:startTime,
        startTime:this.datePipe.transform(startTime,"HH:mm:ss"),
        endTimeInput:endTime,endTime:this.datePipe.transform(endTime,"HH:mm:ss")});
      }
  }

  showEditDevice(device:any){
    this.device=device;
    this.loadDrivingSchedule(device);
    this.displayEditDevice = true;
  }

  showDevices(user:any){
    this.user=user;
    this.displayDevices = true;
    this.devices = [];
    this.deviceService.findByUser(this.user.idUser).then(data => {
      let response: any = data;
      response.devices.forEach(item => {
        this.devices.push(item);
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
    this.device = {status:"H",users:[{idUser:user.idUser}]};
    this.displayAddDevice = false;
    this.displayEditDevice = false;
  }

  hide(){
    this.user = {idProfile : 0, status:"H",idUserParent:this.userService.userLoged.idUser,limitDevices:20};
    this.displayAdd = false;
    this.displayEdit = false;
    this.displayChangePassword = false;
    this.init();
  }

  hideDevices(){
    this.displayDevices = false;
  }

  hideDevice(){
    this.device = {status:"H"};
    this.displayAddDevice = false;
    this.displayEditDevice = false;
  }

  add(){
    if(this.user.password != this.user.passwordConfirm){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Password no coincide"}];
    }else{
      this.blockedDocument = true;
      this.user.expirationDate = this.datePipe.transform(this.expirationDate,"dd/MM/yyyy");
      this.userService.create(this.user).then(data =>{
        let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });
    }
  }

  edit(){
    this.blockedDocument = true;
    this.user.expirationDate = this.datePipe.transform(this.expirationDate,"dd/MM/yyyy");
    this.userService.edit(this.user).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.init();
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      this.blockedDocument = false;
    });
  }

  del(id: string){
    this.confirmationService.confirm({
      message: 'Esta seguro de eliminar el registro seleccionado?',
      header: 'Confirmación',
      icon: 'fa fa-trash',
      accept: () => {
        this.blockedDocument = true;
        this.userService.remove(id).then(data =>{
          let response: any = data;
          if(response.status == 'OK'){
            this.init();
            this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blockedDocument = false;
        }).catch(err =>{
          console.log(err);
          this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
          this.blockedDocument = false;
        });
      }
    });
  }

  addDevice(){
    this.blockedDocument = true;
    this.device.drivingSchedules.forEach(drivingSchedule =>{
      drivingSchedule.startTime = this.datePipe.transform(drivingSchedule.startTimeInput,"HH:mm:ss");
      drivingSchedule.endTime = this.datePipe.transform(drivingSchedule.endTimeInput,"HH:mm:ss")
    });
    this.deviceService.create(this.device).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.showDevices(this.user);
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      this.blockedDocument = false;
    });
  }

  editDevice(){
    this.blockedDocument = true;
    this.device.drivingSchedules.forEach(drivingSchedule =>{
      drivingSchedule.startTime = this.datePipe.transform(drivingSchedule.startTimeInput,"HH:mm:ss");
      drivingSchedule.endTime = this.datePipe.transform(drivingSchedule.endTimeInput,"HH:mm:ss")
    });
    this.deviceService.edit(this.device).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.showDevices(this.user);
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      this.blockedDocument = false;
    });
  }

  delDevice(idDevice: String){
    this.confirmationService.confirm({
      message: 'Esta seguro de eliminar el registro seleccionado?',
      header: 'Confirmación',
      icon: 'fa fa-trash',
      accept: () => {
        this.blockedDocument = true;
        this.userDeviceService.remove(this.user.idUser,idDevice).then(data =>{
          let response: any = data;
          if(response.status == 'OK'){
            this.showDevices(this.user);
            this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blockedDocument = false;
        }).catch(err =>{
          console.log(err);
          this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
          this.blockedDocument = false;
        });
      }
    });
  }

  loadDrivingSchedule(device :any){
    device.drivingSchedules.forEach(drivingSchedule =>{
      let startTimeArray = drivingSchedule.startTime.split(":");
      let endTimeArray = drivingSchedule.endTime.split(":");

      let startTime= new Date();
      startTime.setHours(startTimeArray[0],startTimeArray[1],startTimeArray[2]);
      let endTime = new Date();
      endTime.setHours(endTimeArray[0],endTimeArray[1],endTimeArray[2]);

      drivingSchedule.startTimeInput = startTime;
      drivingSchedule.endTimeInput = endTime;
    });
  }

  updateDrivingSchedule(){
    this.device.drivingSchedules.forEach(drivingSchedule =>{
      drivingSchedule.startTime = this.datePipe.transform(drivingSchedule.startTimeInput,"HH:mm:ss");
      drivingSchedule.endTime = this.datePipe.transform(drivingSchedule.endTimeInput,"HH:mm:ss")
    });
  }

  changePassword(){
    if(this.newPassword != this.confirmPassword){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"El nuevo Password no coincide"}];
      return;
    }

    this.blockedDocument = true;
    this.userService.forcePasswordChange(this.user.idUser,this.newPassword).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.displayChangePassword = false;
        this.msgs = [{severity:'info', summary:'INFO', detail:'Password modificado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      this.blockedDocument = false;
    });
  }

  changeLogin(item:any){
    this.userService.userLoged=item;
    if(item.picture !=null){
      this.userService.urlAvatar = this.userService.mainService.image_url+this.userService.userLoged.picture+'?' + (new Date()).getTime();
    }else{
      this.userService.urlAvatar = "assets/layout/images/avatar.png"+'?' + (new Date()).getTime();
    }
    this.userService.buildMenu();
    this.router.navigate(['home']);
  }

  changeProfile(event){
    this.profileService.find(event.value).then(data=>{
      let response: any = data;
      this.user.storageTime = response.profile.storageTime;
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      this.blockedDocument = false;
    });
  }

  diferenciaEntreDiasEnDias(a:Date, b:Date):number{
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
  }
}



// WEBPACK FOOTER //
// ./src/app/user/user.component.ts